import Vue from 'vue'
import Router from 'vue-router'
import authGuard from './auth-guard';

Vue.use(Router)


const routes = [
    // {
    //       path: '/',
    //       name: 'landing-page',
    //       component: require('@/components/LandingPage').default
    //   },
    {
        path: '/',
        name: 'login',
        component: require('@/components/auth/login').default
    },

    {
        path: '/admin',
        name: 'admin',
        component: require('@/components/admin/adminWrapper.vue').default,
        children: [
            { path: '', redirect: { name: 'admin.dashboard' } },
            { path: 'dashboard', name: 'admin.dashboard', component: require('@/components/admin/adashboard.vue').default,meta: { requiresAuth: true,roles:['administrator'] }, },
            { path: 'customers', name: 'admin.customers', component: require('@/components/admin/customers').default,meta: { requiresAuth: true,roles:['administrator'] }, },
            { path: 'settings', name: 'admin.settings', component: require('@/components/admin/settings').default,meta: { requiresAuth: true ,roles:['administrator']}, },
            { path: 'sms', name: 'admin.sms', component: require('@/components/admin/sms').default,meta: { requiresAuth: true,roles:['administrator'] }, },
            { path: 'users', name: 'admin.users', component: require('@/components/admin/users').default,meta: { requiresAuth: true ,roles:['administrator']}, },
        ]
    },

    {
        path: '/settings',
        name: 'settings',
        component: require('@/components/admin/settings').default,
        meta: { requiresAuth: true,roles:['administrator'] }
    },
    {
        path: '/reports',
        name: 'reports',
        component: require('@/components/admin/reports').default,
        meta: { requiresAuth: true ,roles:['administrator','accountant']}
    },

    {
        path: '/sales',
        name: 'sales',
        component: require('@/components/sales/sdashboard').default,
        meta: { requiresAuth: true,roles:['administrator','vendor'] }
    },
    {
        path: '/debtors',
        name: 'debtors',
        component: require('@/components/sales/debtors').default,
        meta: { requiresAuth: true,roles:['administrator','accountant'] }
    },
    {
        path: '/e-clerk',
        name: 'entry-clerk',
        component: require('@/components/entry-clerk/ecdashboard').default,
        meta: { requiresAuth: true,roles:['administrator','entry_clerk'] }
    },
    {
        path: '/items',
        name: 'items',
        component: require('@/components/entry-clerk/ecdashboard').default,
        meta: { requiresAuth: true,roles:['administrator','entry_clerk'] }
    },


    {
        path: '/accountant',
        component: require('@/components/accountant/accountantWrapper.vue').default,
        children: [
            { path: '', redirect: { name: 'accountant.dashboard' } },
            { path: 'dashboard', name: 'accountant.dashboard', component: require('@/components/accountant/dashboard.vue').default, meta: { requiresAuth: true,roles:['administrator','accountant'] } },
            { path: 'income', name: 'accountant.income', component: require('@/components/accountant/income.vue').default, meta: { requiresAuth: true,roles:['administrator','accountant'] } },
            { path: 'banking', name: 'accountant.banking', component: require('@/components/accountant/banking.vue').default, meta: { requiresAuth: true,roles:['administrator','accountant'] } },
            { path: 'expense', name: 'accountant.expense', component: require('@/components/accountant/expense.vue').default, meta: { requiresAuth: true,roles:['administrator','accountant'] } },
            { path: 'ledgeracc', name: 'accountant.ledgeracc', component: require('@/components/accountant/ledgeracc.vue').default, meta: { requiresAuth: true,roles:['administrator','accountant'] } },
        ]
    },
    {
        path: '*',
        redirect: '/'
    }
]


const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(authGuard)

export default router;